import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import ModalEventBus, { IModal } from 'Events/ModalEventBus';
import { mixins } from 'vue-class-component';
import ModalComponent from 'Components/Utils/Modals/ModalComponent';



@Component({
    template: '#deliveryaddress-modal-component-template',
    //name: 'delivery-address'
    components: {        
        ModalComponent
    }
})
export default class DeliveryAddressModalComponent extends Vue { //TODO- create mixin or inherit for standard functionality
    
    private selectedId: string = null;
    private isAccepted: boolean = false;
    private error: boolean = false;
    
    public obj: IModal;
    
    created() {
        var self = this;
    }
    
    async accept(obj: IModal) {
      
        await obj.success({
        });
    }
    
    async cancel(e: Event, obj: IModal) {
        await obj.close({});
    }
    
}

Vue.component('deliveryaddress-modal-component', DeliveryAddressModalComponent);